export const getSocketState = state => state.socket;
